module.exports = __webpack_public_path__ + "static/img/news-demo3.6762c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/news-demo3.png
// module id = s52Y
// module chunks = 31